import { useRouteLoaderData } from 'react-router';

import { PROFESSIONAL_DETAILS_BASE_ROUTE_ID } from '@modules/business-manager/config/constants';
import type { loader as layoutLoader } from '@modules/professional/page/loaders/professional-page-loader.server';

/**
 * The shared overview payload (identity, summary, featured work, "Talk to us"
 * imagery) the persistent professional layout loads once per professional —
 * the revamped tabs read it from here instead of refetching it per tab
 * switch. Only available while the revamp is active, which is the only time
 * the revamped sections render; throws otherwise so a misplaced usage fails
 * loudly rather than rendering empty.
 */
export const useProfessionalOverviewShared = () => {
    const layoutData = useRouteLoaderData<typeof layoutLoader>(
        PROFESSIONAL_DETAILS_BASE_ROUTE_ID,
    );
    const shared = layoutData?.overviewShared;
    if (!shared) {
        throw new Error(
            'useProfessionalOverviewShared requires the professional layout with the details revamp active',
        );
    }
    return shared;
};
